/**
 * UI Mode Store
 *
 * Manages the user's preferred UI mode:
 * - "command-center": AI-first conversational interface
 * - "deep-data": Traditional detailed UI with sidebar, grids, and detail pages
 *
 * Persisted to localStorage so the preference survives sessions.
 */

import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

export type UIMode = "command-center" | "deep-data";

interface UIModeState {
	mode: UIMode;
	setMode: (mode: UIMode) => void;
	toggleMode: () => void;
}

export const useUIModeStore = create<UIModeState>()(
	persist(
		(set, get) => ({
			mode: "deep-data" as UIMode,
			setMode: (mode: UIMode) => set({ mode }),
			toggleMode: () =>
				set({
					mode: get().mode === "command-center" ? "deep-data" : "command-center",
				}),
		}),
		{
			name: "facilityai-ui-mode",
			storage: createJSONStorage(() => localStorage),
		},
	),
);
